import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';
import { EAU_MODALS } from '../../eau.constants';
import { IEauTableRowProps } from './eau-table.interfaces';

const EauTableRowActions = ({
  record,
  handleModals,
  t,
}: IEauTableRowProps) => {
  const { canEditALl } = useUserCanManageDocument({
    platformPermission: PLATFORM_PERMISSIONS.applications,
  });

  return (
    <Popover
      elements={[
        {
          label: t('common:buttons.edit'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          ...(!canEditALl && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
          handler: () => {
            if (canEditALl) {
              handleModals(EAU_MODALS.edit, record);
            }
          },
        },
        {
          label: t('common:buttons.delete'),
          icon: ICONS.trash,
          color: canEditALl
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,
          key: ICONS.trash,
          handler: () => {
            if (canEditALl) {
              handleModals(EAU_MODALS.delete, record);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default EauTableRowActions;
